import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import Header from "../common/Header/Header";
import { Icon } from "react-icons-kit";
import { users } from "react-icons-kit/feather/users";
import { award } from "react-icons-kit/feather/award";
import { home } from "react-icons-kit/feather/home";
import MemberComponent from "./MemberComponent/MemberComponent";
import BillingComponent from "./BillingComponent/BillingComponent";
import { creditCard } from "react-icons-kit/feather/creditCard";
import LicenseComponent from "./LicenseComponent/LicenseComponent";
import DownloadsComponent from "./DownloadsComponent/DownloadsComponent";
import UpgradeComponent from "./UpgradeComponent/UpgradeComponent";
import { arrowDownCircle } from "react-icons-kit/feather/arrowDownCircle";
import { arrowUpCircle } from "react-icons-kit/feather/arrowUpCircle";
import "../../assets/css/style.css";
import "../../assets/css/components/Profile/Profile.css";
import ProfileForm from "./ProfileForm/ProfileForm";
import Utility from "../../common/utility";

const Profile = inject("sharedStore", "profileStore")(
  observer(store => {
    const {
      profileStore,
      sharedStore,
      history,
      location: { pathname }
    } = store;
    const [activeTab, setActiveTab] = useState("");
    const [isUserlogin, setUserLogin] = useState(false);

    useEffect(() => {
      isLogin();
      setActiveTab(pathname.replace("/", ""));
    }, []);

    const redirectToActiveTab = (e, tabName) => {
      history.push("/" + tabName);
      setActiveTab(tabName);
    };

    const isLogin = () => {
      sharedStore.showLoader();
      return profileStore
        .isUserLoggedIn()
        .then(resp => {
          sharedStore.hideLoader();
          if (resp && resp.status_code === 400) {
            sharedStore.hideLoader();
            Utility.clearAllData();
            history.push("/");
          } else if (resp && resp.status_code === 200) {
            Utility.setData("userId", resp.user_id);
            Utility.setData("companyId", resp.companyId);
            Utility.setData("companyName", resp.companyName);
            sharedStore.getLicenseData();
            sharedStore.getMemebersData();
            sharedStore.fetchResources();
            sharedStore.setLoginDropDown(true);
            sharedStore.fetchInvoiceList();
            sharedStore.fetchVersion();
            sharedStore.getCurrentVersion();
            sharedStore.fetchNumberOfLicenses({
              company_id: Utility.getData("companyId")
            });
            setUserLogin(true);
          } else {
            history.push("/");
          }
        })
        .catch(err => {
          sharedStore.hideLoader();
          console.log("err", err);
        });
    };

    const renderTabData = () => {
      switch (activeTab) {
        case "member":
          return <MemberComponent />;
        case "invoice":
          // return ""
          return <BillingComponent />;
        case "license":
          return <LicenseComponent />;
        case "download":
          return <DownloadsComponent />;
        case "upgrade":
          return <UpgradeComponent />;
        case "profile":
          return <ProfileForm />;
        default:
          return;
      }
    };

    return isUserlogin ? (
      <div className="dashboard_mainwrapper">
        <div className="headernew_wrapper">
          <Header />
        </div>

        <div className="profileContent">
          <div className="dash_sidenav" id="mainSideNav">
            <ul className="customSidenav" id="customSidenavbar">
              <li
                className={activeTab === "profile" ? "active" : ""}
                onClick={e => redirectToActiveTab(e, "profile")}
              >
                <Icon className="sideNavIcon" icon={home} />
                <span>Profile</span>
              </li>
              <li
                className={activeTab === "member" ? "active" : ""}
                onClick={e => redirectToActiveTab(e, "member")}
              >
                <Icon className="sideNavIcon" icon={users} />
                <span>Members</span>
              </li>
              <li
                className={activeTab === "invoice" ? "active" : ""}
                onClick={e => redirectToActiveTab(e, "invoice")}
              >
                <Icon className="sideNavIcon" icon={creditCard} />
                <span>Invoice</span>
              </li>
              {sharedStore.customerSeriesType === 0 ? null : (
                <li
                  className={activeTab === "license" ? "active" : ""}
                  onClick={e => redirectToActiveTab(e, "license")}
                >
                  <Icon className="sideNavIcon" icon={award} />
                  <span>Licenses</span>
                </li>
              )}
              {sharedStore.customerSeriesType === 0 ? null : (
                <li
                  className={activeTab === "upgrade" ? "active" : ""}
                  onClick={e => redirectToActiveTab(e, "upgrade")}
                >
                  <Icon className="sideNavIcon" icon={arrowUpCircle} />
                  <span>Upgrade</span>
                  {/* <span className="new_version">New Version</span> */}
                </li>
              )}
              <li
                className={activeTab === "download" ? "active" : ""}
                onClick={e => redirectToActiveTab(e, "download")}
              >
                <Icon className="sideNavIcon" icon={arrowDownCircle} />
                <span>Downloads</span>
              </li>
            </ul>
          </div>
          <div className="mar50 tab_wrapper">{renderTabData()}</div>
        </div>
      </div>
    ) : null;
  })
);

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.jsx